import React from 'react';

const Footer = () => {
    return (
        <div className='flex items-center justify-center text-textColor hover:text-headingColor text-sm'>
            © 2022, UniShoes
        </div>
    )
}

export default Footer;